<template>
  <p
    class="tw:flex tw:gap-0"
    data-testid="totals-by-status"
  >
    <!-- having span elements below in separate lines causes a space to be added in HTML between them -->
    <!-- as a result, there's a space before the comma; gap-0 class prevents this space from being visible -->
    <template
      v-for="(totalData, index) in displayableTotalsByStatus"
      :key="totalData.status"
    >
      <span
        :class="totalData.class"
        :data-testid="`${totalData.status}-total`"
      >
        {{ totalData.text }}
        <BaseStreemTooltip>{{ totalTooltip(totalData) }}</BaseStreemTooltip>
      </span>
      <span v-if="index < displayableTotalsByStatus.length - 1">,&nbsp;</span>
    </template>
  </p>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseStreemTooltip } from "shared/components/base";

import { type UrlData } from "../shared/types";

import {
  displayableTotalsByStatus as getDisplayableTotalsByStatus,
  type UrlsTotalForStatus,
} from "./shared";

defineOptions({
  name: "UrlsTotalsByStatus",
});

export type UrlsTotalsByStatusProps = {
  urlsData: UrlData[];
};

const props = defineProps<UrlsTotalsByStatusProps>();

const displayableTotalsByStatus = computed<UrlsTotalForStatus[]>(() =>
  getDisplayableTotalsByStatus(props.urlsData)
);

function totalTooltip(totalData: UrlsTotalForStatus): string {
  return getLocaleText(
    `external_items_bulk_add_modal.total_tooltip.${totalData.status}`
  );
}
</script>
